import React from "react";
import OperatorServiceTickets from "../../components/dashboard/OperatorServiceTickets";

const OperatorPlatformJuridique = () => (
  <OperatorServiceTickets
    serviceCode="juridique"
    title="Suivi juridique"
    lead="Les demandes juridiques des clients."
  />
);

export default OperatorPlatformJuridique;
